"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _TextMenu = _interopRequireDefault(require("./TextMenu"));

var _TextMenu2 = _interopRequireDefault(require("./TextMenu2"));

var _Theme = _interopRequireDefault(require("../../assets/Theme7.css"));

var _bind = _interopRequireDefault(require("classnames/bind"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var cx = _bind["default"].bind(_Theme["default"]);

var MenuRender = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(MenuRender, _React$PureComponent);

  function MenuRender() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      animation: false
    });

    _defineProperty(_assertThisInitialized(_this), "getCommonProps", function () {
      var _this$props = _this.props,
          isShow = _this$props.isShow,
          disableTip = _this$props.disableTip,
          ui = _this$props.ui;
      var animation = _this.state.animation;
      return {
        animation: animation,
        isShow: isShow,
        disableTip: disableTip,
        ui: ui
      };
    });

    _defineProperty(_assertThisInitialized(_this), "renderLevel1", function () {
      var _this$props2 = _this.props,
          selecteLevel1Id = _this$props2.selecteLevel1Id,
          level1 = _this$props2.level1,
          onClickLevel1 = _this$props2.onClickLevel1,
          style = _this$props2.style,
          _this$props2$ui = _this$props2.ui,
          ui = _this$props2$ui === void 0 ? {} : _this$props2$ui;
      if (!level1 || level1.length <= 1) return null;

      var props = _extends({
        selected: selecteLevel1Id,
        data: level1
      }, _this.getCommonProps(), {
        onClick: onClickLevel1
      });

      return /*#__PURE__*/_react["default"].createElement("div", {
        style: _extends({}, style, {
          background: ui.panelBgColor
        }),
        className: cx("Level1Theme7")
      }, /*#__PURE__*/_react["default"].createElement(_TextMenu["default"], props));
    });

    _defineProperty(_assertThisInitialized(_this), "renderLevel2", function () {
      var _this$props3 = _this.props,
          selecteLevel2Id = _this$props3.selecteLevel2Id,
          level2 = _this$props3.level2,
          onClickLevel2 = _this$props3.onClickLevel2;
      if (!level2 || level2.length <= 1) return null;

      var props = _extends({
        selected: selecteLevel2Id,
        data: level2
      }, _this.getCommonProps(), {
        onClick: onClickLevel2
      });

      return /*#__PURE__*/_react["default"].createElement(_TextMenu["default"], props);
    });

    _defineProperty(_assertThisInitialized(_this), "renderPano", function () {
      var _this$props4 = _this.props,
          scenesId = _this$props4.scenesId,
          pano = _this$props4.pano,
          onClickPano = _this$props4.onClickPano;

      var props = _extends({
        selected: scenesId,
        data: pano
      }, _this.getCommonProps(), {
        onClick: onClickPano
      });

      return /*#__PURE__*/_react["default"].createElement(_TextMenu2["default"], props);
    });

    return _this;
  }

  var _proto = MenuRender.prototype;

  _proto.render = function render() {
    var _this$props5 = this.props,
        style = _this$props5.style,
        ui = _this$props5.ui;
    return /*#__PURE__*/_react["default"].createElement("div", null, this.renderLevel1(), /*#__PURE__*/_react["default"].createElement("div", {
      style: _extends({}, style, {
        background: ui.panelBgColor
      }),
      className: cx("Level2Theme7")
    }, this.renderLevel2(), this.renderPano()));
  };

  return MenuRender;
}(_react["default"].PureComponent);

var _default = MenuRender;
exports["default"] = _default;
module.exports = exports.default;